export const accessNames = {
  fullAccess: "fullAccess",
  user: "user",
  application: "appeal",
  notification: "notification",
  employee: "employee",
  role: "role",
  log: "log",
  cms: "cms",
  banner: "banner",
  matching: "matching",
  marketing: "marketing",
  mvp: "mvp",
  settings: "settings",
  mobileConfig: "mobileConfig"
};
